import { TimePicker as MUITimePicker } from '@mui/x-date-pickers';
import { dateFromTime } from '@utils/dates';
import { isDate } from 'date-fns';
import { forwardRef } from 'react';
import { MaterialThemeWrapper } from "theme";

export const TimePicker = forwardRef(function TimePicker(props, ref) {
    // @ts-ignore
    let {value, ...restProps} = props;
    if(value && !isDate(value)) {
        value = dateFromTime(value);
    }

    return (
        <MaterialThemeWrapper>
            <MUITimePicker
                slotProps={{ field: { clearable: true } }}
                ref={ref}
                /*
                id={name}
                formatDensity="spacious"
                slotProps={{
                    field: {
                    clearable: true,
                    },
                }}
                onChange={(value) => {
                    if(value) {
                    value = formatDateForDatabase(value);
                    }
                    onChange(value);
                }}
                {...fieldProps}
                */
                // {...props}
                value={value}
                {...restProps}
            />
        </MaterialThemeWrapper>
    );
});
